import { ElMessage, ElMessageBox, ElNotification, ElLoading } from 'element-plus';
import request from '../api/request';
import axios from "axios";
import clipBoard from 'vue-clipboard3';
let { toClipboard } = clipBoard(); // 一键复制
import store from '@/store/index';
import emitter from './eventBus';
import router from '@/router';
export class Feedback {
    constructor() {
        this.loadingInstance = null;
        this.fetchBinaryData = async (url) => {
            try {
                const response = await axios.get(url, {
                    responseType: 'blob'
                });
                return response.data;
            }
            catch (error) {
                console.error('Error fetching binary data:', error);
                throw error;
            }
        };
        // 历史记录通讯
        this.historyEmitter = (routePath, isJump = false) => {
            if (store.state.sidebarJump && routePath == store.state.sidebarJump) {
                emitter.emit('jumpInit', {});
                store.commit('setSidebarJump', '');
                return;
            }
            let status = false;
            // 历史详情
            let historyItem = JSON.parse(JSON.stringify(store.state.histroySelect || {}));
            // AI表格
            if ((historyItem === null || historyItem === void 0 ? void 0 : historyItem.modelName) === 'excel') {
                if (routePath === '/tabulation') {
                    emitter.emit('historyHandle', historyItem);
                }
                else if (isJump) {
                    router.push(`/tabulation?id=${historyItem.id}`);
                }
                status = true;
            }
            // deepseek
            if ((historyItem === null || historyItem === void 0 ? void 0 : historyItem.modelType) == 3 || (historyItem === null || historyItem === void 0 ? void 0 : historyItem.modelType) == 5) {
                if (routePath === '/deepseek') {
                    emitter.emit('historyHandle', historyItem);
                }
                else if (isJump) {
                    router.push(`/deepseek?id=${historyItem.id}`);
                }
                status = true;
            }
            // 图片理解
            if ((historyItem === null || historyItem === void 0 ? void 0 : historyItem.modelType) == 6) {
                if (routePath === '/imagecomprehend') {
                    emitter.emit('historyHandle', historyItem);
                }
                else {
                    router.push(`/imagecomprehend?historyId=${historyItem.id}`);
                }
                status = true;
            }
            // 正常对话
            if (!status) {
                let viewType = this.getViewType(historyItem);
                let params = {};
                // 写作
                if (viewType == 'writing') {
                    params = {
                        wirteQuery: {
                            bot: historyItem === null || historyItem === void 0 ? void 0 : historyItem.modelName,
                            botKey: '',
                            is_setp: false
                        }
                    };
                }
                // 缓存
                store.commit('setChat', {
                    keyword: '',
                    type: viewType,
                    is_create: false,
                    ...params
                });
                emitter.emit('historyHandle', historyItem);
                let jumpUrl = viewType == 'drawing' ? `/drawing_chat?chatid=${historyItem.id}&viewType=${viewType}` : `/chat?chatid=${historyItem.id}&viewType=${viewType}`;
                router.push(jumpUrl);
            }
            store.commit('setHistroySelect', {});
        };
        // 对话中提示
        this.chatTips = (routePath, toPath = '') => {
            return new Promise((resolve, reject) => {
                if (!store.state.chatStatus)
                    return resolve(true);
                let tipsText = store.state.chatStatus == 'pptOutline' ? '您正在生成PPT大纲中，切换页面会生成失败，确认切换？' : store.state.chatStatus == 'drawing' ? '绘画任务进行中，切换页面绘画仍会继续生成，确认切换？' : '您正在对话中，切换页面会中断回答。';
                feedback.confirm(tipsText).then((res) => {
                    // 跳转路由不存在或跳转路由与当前路由相同
                    if (!toPath || toPath == routePath) {
                        this.historyEmitter(routePath);
                    }
                    store.commit('setChatStatus', '');
                    resolve(true);
                }).catch((err) => {
                    reject(false);
                });
            });
        };
        this.routeTips = async (type = 'route', routePath = '', toPath = '') => {
            // 需要提示方可跳转
            let tipsRoute = ['/meeting/room', '/simultaneousTranslation/generate']; // 需提示路由
            let baiRoute = ['/meeting/detail']; // 白名单
            if (tipsRoute.includes(routePath) && window.localStorage.getItem('token')) {
                if (type == 'route' && baiRoute.includes(toPath))
                    return false;
                try {
                    await feedback.confirm('您正在录制中，确定要切换页面吗？');
                    return false;
                }
                catch (error) {
                    return true;
                }
            }
            // 通话
            if (routePath === '/voicecall' && store.state.voicecallStatus) {
                try {
                    await feedback.confirm('您正在通话中，确定要切换页面吗？');
                    return false;
                }
                catch (error) {
                    return true;
                }
            }
            // 智能体
            if (store.state.intelligenceStatus && routePath === '/intelligence_chat') {
                try {
                    await feedback.confirm('您正在智能体对话中，切换页面会中断回答。');
                    return false;
                }
                catch (error) {
                    return true;
                }
            }
            // 对话提示
            try {
                await feedback.chatTips(routePath, toPath);
            }
            catch (error) {
                return true;
            }
            return false;
        };
    }
    static getInstance() {
        var _a;
        return (_a = this.instance) !== null && _a !== void 0 ? _a : (this.instance = new Feedback());
    }
    // 消息提示
    msg(msg, duration = 3000) {
        ElMessage.info({
            message: msg,
            duration: duration
        });
    }
    // 错误消息
    msgError(msg, duration = 3000) {
        ElMessage.error({
            message: msg,
            duration: duration
        });
    }
    // 成功消息
    msgSuccess(msg, duration = 3000) {
        ElMessage.success({
            message: msg,
            duration: duration
        });
    }
    // 警告消息
    msgWarning(msg, duration = 3000) {
        ElMessage.warning({
            message: msg,
            duration: duration
        });
    }
    // 弹出提示
    alert(msg) {
        ElMessageBox.alert(msg, '系统提示');
    }
    // 错误提示
    alertError(msg) {
        ElMessageBox.alert(msg, '系统提示', { type: 'error' });
    }
    // 成功提示
    alertSuccess(msg) {
        ElMessageBox.alert(msg, '系统提示', { type: 'success' });
    }
    // 警告提示
    alertWarning(msg) {
        ElMessageBox.alert(msg, '系统提示', { type: 'warning' });
    }
    // 通知提示
    notify(msg) {
        ElNotification.info(msg);
    }
    // 错误通知
    notifyError(msg) {
        ElNotification.error(msg);
    }
    // 成功通知
    notifySuccess(msg) {
        ElNotification.success(msg);
    }
    // 警告通知
    notifyWarning(msg) {
        ElNotification.warning(msg);
    }
    // 确认窗体
    confirm(msg) {
        return ElMessageBox.confirm(msg, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        });
    }
    // 提交内容
    prompt(content, title, options) {
        return ElMessageBox.prompt(content, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            ...options
        });
    }
    // 打开全局loading
    loading(msg, transparency = '0.2', target = document.body) {
        this.loadingInstance = ElLoading.service({
            target: target,
            lock: true,
            text: msg,
            background: `rgba(255, 255, 255, ${transparency})`,
        });
    }
    // 关闭全局loading
    closeLoading() {
        var _a;
        (_a = this.loadingInstance) === null || _a === void 0 ? void 0 : _a.close();
    }
    // 复制
    async copyText(text, tips = '') {
        if (!text)
            return console.error('复制数据不可为空');
        let newStr = text.replace(/<br \/>/g, "\n") || text;
        try {
            await toClipboard(newStr);
            if (tips)
                this.msgSuccess(tips);
        }
        catch (error) {
        }
    }
    async downloadFile(datas, filename = '', fileType = 'pptx') {
        const blob = await this.urlToBlob(datas);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.${fileType}`;
        a.click();
        URL.revokeObjectURL(url); // 释放资源
    }
    async downloadFileData(datas, filename = '') {
        const blob = await this.urlToBlob(datas);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.generateFileName(datas, filename);
        a.click();
        URL.revokeObjectURL(url); // 释放资源
    }
    getFileExtension(url) {
        const match = url === null || url === void 0 ? void 0 : url.match(/\.([a-z0-9]+)(\?.*)?$/i);
        if (!match)
            return null;
        return match[1].toLowerCase();
    }
    generateFileName(url, defaultName) {
        const extension = this.getFileExtension(url);
        return extension ? `${defaultName}.${extension}` : defaultName;
    }
    async urlToBlob(url) {
        try {
            const response = await axios.get(url, { responseType: 'blob' });
            return response.data; // Blob 对象
        }
        catch (error) {
            console.error('Error fetching and converting to blob:', error);
            throw error;
        }
    }
    encodeBase64(input) {
        try {
            return btoa(input);
        }
        catch (error) {
            console.error("Base64 编码失败:", error);
            return null;
        }
    }
    random8DigitNumber() {
        return Math.floor(10000000 + Math.random() * 90000000);
    }
    // 获取类型
    getViewType(item) {
        const { modelName, modelType } = item;
        const keys = ['drawing', 'mbti', 'translate', 'image'];
        const writingKey = ['article', 'writing'];
        if (modelType == 8)
            return 'chat';
        return keys.includes(modelName) ? modelName : writingKey.includes(modelName) ? 'writing' : 'chat';
    }
    // 历史记录跳转配置
    getRouteJump(key, item = {}, jumpData = { routePath: '', isJump: false }) {
        const { routePath, isJump } = jumpData;
        if (store.state.sidebarJump && routePath == store.state.sidebarJump) {
            emitter.emit('jumpInit', {});
            store.commit('setSidebarJump', '');
            return;
        }
        if (!key)
            return '';
        let jumpUrl = '';
        switch (key) {
            // ai对话
            case 'CHAT_AI_WRITING':
            case 'CHAT_BASIC_CHAT':
            case 'CHAT_TRANSLATE':
                let viewType = key === 'CHAT_AI_WRITING' ? 'writing' : key === 'CHAT_TRANSLATE' ? 'translate' : 'chat';
                jumpUrl = `/chat?chatid=${item === null || item === void 0 ? void 0 : item.id}&viewType=${viewType}`;
                if (isJump) {
                    let params = {};
                    if (key === 'CHAT_AI_WRITING') {
                        params = {
                            wirteQuery: {
                                bot: item === null || item === void 0 ? void 0 : item.modelName,
                                botKey: '',
                                is_setp: false
                            }
                        };
                    }
                    // 缓存
                    store.commit('setChat', {
                        keyword: '',
                        type: viewType,
                        is_create: false,
                        ...params
                    });
                    emitter.emit('historyHandle', item);
                    router.push(jumpUrl);
                }
                break;
            // 图片理解
            case 'CHAT_IMAGE_UNDERSTANDING':
                jumpUrl = `/imagecomprehend?historyId=${item === null || item === void 0 ? void 0 : item.id}`;
                if (routePath === '/imagecomprehend') {
                    emitter.emit('imagecomprehendHistory', item);
                }
                else if (isJump) {
                    router.push(jumpUrl);
                }
                break;
            // AI表格
            case 'CHAT_AI_TABLE':
                jumpUrl = `/tabulation?id=${item === null || item === void 0 ? void 0 : item.id}`;
                if (routePath === '/tabulation') {
                    emitter.emit('tabulationHistory', item);
                }
                else if (isJump) {
                    router.push(jumpUrl);
                }
                break;
            // 会议 | 同声传译
            case 'MEETING':
            case 'TRANSLATION':
                let jumpId = key == 'MEETING' ? item === null || item === void 0 ? void 0 : item.id : item === null || item === void 0 ? void 0 : item.meetingId;
                let jumpViewType = key == 'MEETING' ? 'meeting' : 'translation';
                let jumpTitle = item === null || item === void 0 ? void 0 : item.title;
                let jumpTranslationId = key == 'MEETING' ? '' : item === null || item === void 0 ? void 0 : item.id;
                jumpUrl = `/meeting/detail?id=${jumpId}&type=${jumpViewType}&title=${jumpTitle}&showTitle=1&translationId=${jumpTranslationId}`;
                if (routePath === '/meeting/detail') {
                    emitter.emit('meetingHistory', {
                        translationId: jumpTranslationId,
                        id: jumpId,
                        type: jumpViewType,
                        title: jumpTitle
                    });
                }
                else if (isJump) {
                    router.push(jumpUrl);
                }
                break;
            // PPT
            case 'PPT':
                jumpUrl = `/preview?id=${item === null || item === void 0 ? void 0 : item.id}&taskId=${item === null || item === void 0 ? void 0 : item.taskRecordId}&title=${item === null || item === void 0 ? void 0 : item.title}&url=${item === null || item === void 0 ? void 0 : item.pptUrl}`;
                if (routePath === '/preview') {
                    emitter.emit('preview', item);
                }
                else if (isJump) {
                    router.push(jumpUrl);
                }
                break;
            case 'IMAGE':
                jumpUrl = `/drawing_chat?chatid=${item === null || item === void 0 ? void 0 : item.id}&viewType=drawing`;
                if (routePath === '/drawing_chat') {
                    emitter.emit('drawingHistory', item);
                }
                else if (isJump) {
                    router.push(jumpUrl);
                }
                break;
            default:
                jumpUrl = '';
                break;
        }
        return jumpUrl;
    }
    handleDeleteSingle(item) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await feedback.confirm('确定删除该条消息吗？');
                if (res === 'confirm') {
                    const res = await request.delete(`app-api/lt/ai/chat/message/delete?id=${item.id}`, {});
                    if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
                        feedback.msgSuccess('删除成功');
                        resolve(true);
                    }
                    else {
                        feedback.msgError((res === null || res === void 0 ? void 0 : res.msg) || '删除失败');
                        reject(false);
                    }
                }
            }
            catch (error) {
                reject(false);
            }
        });
    }
    // 校验token是否失效
    async checkToken() {
        // let res;
        // try {
        //     res = await request.get('', {})
        // } catch (error) { }
        // if (res?.code == 401) {
        //     return false
        // } else {
        //     return true
        // }
    }
}
Feedback.instance = null;
const feedback = Feedback.getInstance();
export default feedback;
